import { createContext } from 'react'

export interface VideoContextType {
  isMainElement: boolean
}

const VideoContext = createContext<VideoContextType>({
  isMainElement: false,
})

export default VideoContext
